import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export enum ThreadIngestionStatus {
  // The thread's latest email is still being ingested or processed
  InFlight = 'inFlight',
  NotInFlight = 'notInFlight',
}

type ThreadIngestionStatusResponse = {
  status: ThreadIngestionStatus;
};

export async function getThreadIngestionStatus(
  threadID: string
): Promise<Result<ThreadIngestionStatus, ApiError>> {
  try {
    const response = await axios.get<ThreadIngestionStatusResponse>(
      `email/ingest/status/${encodeURIComponent(threadID)}`
    );
    return ok(response.data.status);
  } catch (error) {
    captureException(error, { functionName: 'getThreadIngestionStatus' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get thread ingestion status' });
    }

    return err({
      message:
        error.response?.data.message || 'Failed to get thread ingestion status',
    });
  }
}
